import sharedContentService from "@/services/mrfiktiv/services/sharedContentService";
import {
  MrfiktivCreateSharedContentElementDtoGen,
  MrfiktivSharedContentAccessViewmodelGen,
  MrfiktivSharedContentViewmodelGen
} from "@/services/mrfiktiv/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, Module, Mutation, VuexModule, getModule } from "vuex-module-decorators";

/**
 * Store to handle shared contents
 */
@Module({
  dynamic: true,
  namespaced: true,
  name: "shared-content",
  store
})
export class SharedContentStore extends VuexModule {
  /**
   * A single shared content
   */
  private _sharedContent: MrfiktivSharedContentViewmodelGen | undefined = undefined;

  /**
   * Returns the shared content
   */
  get sharedContent(): MrfiktivSharedContentViewmodelGen | undefined {
    return this._sharedContent;
  }

  /**
   *
   * mutates the acitve shared content
   *
   * @param sharedContent
   */
  @Mutation
  private _mutateSharedContent(sharedContent: MrfiktivSharedContentViewmodelGen): void {
    this._sharedContent = sharedContent;
  }

  /**
   * Creates a shared content
   *
   * @param data dto to create a shared content
   */
  @Action
  async create(data: {
    partnerId: string;
    data: MrfiktivCreateSharedContentElementDtoGen;
  }): Promise<MrfiktivSharedContentViewmodelGen> {
    const created = await sharedContentService.create(data.partnerId, data.data);
    this.context.commit("_mutateSharedContent", created);

    return created;
  }

  /**
   * Gets a shared content
   *
   * @param data dto to get a shared content
   */
  @Action
  async get(data: { partnerId: string; sharedContentId: string }): Promise<MrfiktivSharedContentViewmodelGen> {
    const found = await sharedContentService.get(data.partnerId, data.sharedContentId);
    this.context.commit("_mutateSharedContent", found);

    return found;
  }

  /**
   * delete a shared content
   *
   * @param data dto to delete a shared content
   */
  @Action
  async delete(data: { partnerId: string; sharedContentId: string }): Promise<MrfiktivSharedContentViewmodelGen> {
    const deleted = await sharedContentService.delete(data.partnerId, data.sharedContentId);
    this.context.commit("_mutateSharedContent", deleted);

    return deleted;
  }

  /**
   * Gets a shared content
   *
   * @param data dto to get a shared content
   */
  @Action
  async update(data: {
    partnerId: string;
    sharedContentId: string;
    data: MrfiktivCreateSharedContentElementDtoGen;
  }): Promise<MrfiktivSharedContentViewmodelGen> {
    const updated = await sharedContentService.update(data.partnerId, data.sharedContentId, data.data);
    this.context.commit("_mutateSharedContent", updated);

    return updated;
  }

  /**
   * Gets a shared content
   *
   * @param data dto to get a shared content
   */
  @Action
  async access(data: {
    partnerId: string;
    sharedContentId: string;
    accessToken: string;
  }): Promise<MrfiktivSharedContentAccessViewmodelGen> {
    const access = await sharedContentService.sharedContentReportControllerAccessForPartner(
      data.partnerId,
      data.sharedContentId,
      data.accessToken
    );

    return access;
  }
}

export const SharedContentModule = getModule(SharedContentStore);
